<template>
  <main id="js-page-content" role="main" class="page-content">
    <div
      class="h-alt-hf d-flex flex-column align-items-center justify-content-center text-center"
    >
      <h1 class="page-error color-fusion-500">
        ERROR <span class="text-gradient">404</span>
        <small class="fw-500"> アクセスしたページは存在しません</small>
      </h1>
      <h3 class="fw-500 mb-5">管理者に問い合わせてください</h3>
    </div>
  </main>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({})
export default class Error extends Vue {}
</script>
